import { DataSource, Image, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReeferTempQuickInfo extends Layout {
    imageReturnAirTemp: Image;
    imageSetPointTemp: Image;
    panelReeferTemps: Panel;
    sourceOrders: DataSource;
    textboxComSetpntTemp: Textbox;
    textboxReturnTemp: Textbox;
    textboxSetpointTemp: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
}
